import { createApp } from 'vue'
import EventsApp from './components/events/EventsApp.vue'

const el = document.getElementById('events-app')

if (el && window.eventsData) {
    createApp(EventsApp, { config: window.eventsData }).mount(el)
}
